exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}[data-reactroot]{min-height:100%}div{outline:none}.mobile-banner{height:20px;background-color:rgba(0,0,0,.32);position:absolute;top:0;left:0;width:100%}.mobile-banner--bottom{bottom:0}.web-banner{display:flex;flex-direction:column-reverse}.web-banner--bottom{position:absolute;bottom:0;width:100%;z-index:99}.app-container{height:100%;width:100%}.app-container--small-banner{position:absolute;top:0;left:0}.app-container--big-banner{height:calc(100vh - 50px)}@media only screen and (min-device-width:320px) and (max-device-width:1034px){.app-container{position:absolute;height:100%;width:100%}}.main-container{height:100%;z-index:0;background-color:#f2f4f6}.invalid-permissions{width:100%;height:40%;margin-top:30vh;text-align:center}.invalid-permissions p{font-family:Open Sans,sans-serif;font-weight:700;font-size:36px;color:red}.no-company-selected{width:100%;height:40%;margin-top:30vh;text-align:center}.no-company-selected p{font-family:Open Sans,sans-serif;font-weight:700;font-size:36px;color:#000}::-webkit-input-placeholder{color:#bababa;background-color:transparent;font-size:13px}:-moz-placeholder,::-moz-placeholder{color:#bababa;background-color:transparent;font-size:13px}:-ms-input-placeholder{color:#bababa;background-color:transparent;font-size:13px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/App.scss
// module id = 1515
// module chunks = 0